import React, { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import "./ContactForm.scss";
import zohoSender, { zohoFormData, zohoFormInfo } from "./ZohoSender";
import { t } from "ttag";

type FormData = {
  firstName: string;
  lastName: string;
  email: string;
};

type FormInfo = {
  successElement: HTMLDivElement;
  errorElement: HTMLDivElement;
  formElement: HTMLElement;
};

const SubscribeForm: FunctionComponent<any> = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormData, FormInfo>();


  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const onsubmit = (data) => {
    zohoSender({
      First_Name: "Newsletter",
      Last_Name: "Subscriber",
      Email: data.email,
      Rating: "Hot",
      Lead_Source: "Newsletter"
    },
      {
        successElement: document.querySelector('.SubscribeForm-success'),
        errorElement: document.querySelector('.SubscribeForm-errorMessage'),
        formElement: document.querySelector('#SubscribeForm'),
      });
  };

  return (
    <div className="Subscribe-form">
      <h2>{t`Form.Subscribe.Title`}</h2>

      <form id="SubscribeForm" className="ContactForm SubscribeForm" onSubmit={handleSubmit(onsubmit)} >
        <div className="ContactForm-field">
          <label htmlFor="email">{t`Form.Email.Label`}</label>
          <input
            type="email"
            {...register("email", {
              required: true,
              pattern: emailRegex,
            })}
          />
          {errors?.email?.type === "required" && (
            <div className="ContactForm-error">{t`Form.Error.Required`}</div>
          )}
          {errors?.email?.type === "pattern" && (
            <div className="ContactForm-error">{t`Form.Error.Pattern`}</div>
          )}
        </div>
        <button className="Button Button--primary" type="submit">
          {t`Form.Subscribe`}
        </button>
      </form>
      <div className="SubscribeForm-success">{t`Form.SuccessSubscription`}</div>
      <div className="SubscribeForm-errorMessage">{t`Form.ErrorSubscription`}</div>
      <p>
        By sending your email you agree with <a href="/privacy-policy">privacy policy.</a>
      </p>
    </div>
  );
};

export default SubscribeForm;
